import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=2d6dd6fc&"
import script from "./MaintenancePage.vue?vue&type=script&lang=ts&"
export * from "./MaintenancePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports